import React from "react";
import ReactDOM from "react-dom";
import { Router, Route, browserHistory, IndexRoute } from "react-router";
import "hint.css/hint.css";
import "./styles/build/main.css";
import "./scripts/sdks/firebase";

import App from "./scripts/components/App";
import PageHome from "./scripts/components/PageHome";
import PageVideo from "./scripts/components/PageVideo";
import PageNotFound from "./scripts/components/PageNotFound";

function render() {
  ReactDOM.render(
    <Router history={browserHistory}>
      <Route path="/" component={App}>
        <IndexRoute component={PageHome} />
        <Route path=":id~:start~:end" component={PageVideo} />
        <Route path="*" component={PageNotFound} />
      </Route>
    </Router>,
    document.getElementById("root")
  );
}

render();



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/